import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { type Edges, SafeAreaView } from 'react-native-safe-area-context';

import { theme } from '@garnish/constants';

import { Button } from '../../../Button';
import { Modal, ModalDialogue } from '../../../Modal';
import { TitleText } from '../../../Text';

import type { PickerModalProps } from '../Picker.types';

// ─────────────────────────────────────────────────────────────────────────────

export const PickerModalDialogue = (props: PickerModalProps) => {
  const { show, label, submitBtnLabel, labelNativeID, children, onSubmit, onDismiss } = props;

  return (
    <ModalDialogue visible={show} onRequestClose={onDismiss}>
      <View style={styles.modalContentWrapper}>
        {label ? (
          <TitleText nativeID={labelNativeID} size={6} style={styles.modalTitle}>
            {label}
          </TitleText>
        ) : null}

        {children}
      </View>

      <SafeAreaView edges={SAFE_AREA_VIEW_EDGES}>
        <Modal.Footer style={styles.modalFooter}>
          <Button onPress={onSubmit} accessibilityRole="button" size="large">
            {submitBtnLabel}
          </Button>
        </Modal.Footer>
      </SafeAreaView>
    </ModalDialogue>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const SAFE_AREA_VIEW_EDGES: Edges = Platform.select({
  android: ['bottom'],
  default: [],
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  modalContentWrapper: {
    paddingHorizontal: theme.spacing['4'],
  },
  modalTitle: {
    paddingBottom: theme.spacing['2'],
  },
  modalFooter: {
    paddingBottom: Platform.select({
      android: theme.spacing['4'],
      default: theme.spacing['2'],
    }),
  },
});
